export default "__VITE_ASSET__BKdsR3B9__"